import { Anchor, Stack, Text, Title } from "@mantine/core";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { NavBarContainer } from "./NavBarContainer";
// eslint-disable-next-line @typescript-eslint/no-require-imports
const dinlabeldistribuidores = require("url:../assets/DinLabelDistribuidores.pdf");

type Props = {
  children: React.ReactNode;
};

function Question({ children }: Props) {
  return (
    <Title order={5} mt="md">
      {children}
    </Title>
  );
}

function Answer({ children }: Props) {
  return <Text>{children}</Text>;
}

export function Faq() {
  const { t } = useTranslation();

  return (
    <NavBarContainer>
      <Stack gap="xs">
        <Anchor href={dinlabeldistribuidores}>
          {t("portal.distributorInfo")}
        </Anchor>

        <Question>{t("faq.qGoogleAccount")}</Question>
        <Answer>{t("faq.aGoogleAccount")}</Answer>

        <Question>{t("faq.qRequirements")}</Question>
        <Answer>
          {t("faq.aRequirementsBefore")}{" "}
          <Anchor component={Link} to="/distributorportal">
            {t("faq.aRequirementsLink")}
          </Anchor>{" "}
          {t("faq.aRequirementsAfter")}
        </Answer>

        <Question>{t("faq.qAnyoneCanSell")}</Question>
        <Answer>{t("faq.aAnyoneCanSell")}</Answer>

        <Question>{t("faq.qHowManyDistributors")}</Question>
        <Answer>{t("faq.aHowManyDistributors")}</Answer>

        <Question>{t("faq.qDistributorCost")}</Question>
        <Answer>{t("faq.aDistributorCost")}</Answer>

        <Question>{t("faq.qRecommendedPrice")}</Question>
        <Answer>{t("faq.aRecommendedPrice")}</Answer>

        <Question>{t("faq.qWhereToBuy")}</Question>
        <Answer>
          {t("faq.aWhereToBuyBefore")}{" "}
          <Anchor href="https://www.dinlabel.com">www.dinlabel.com</Anchor>
        </Answer>

        <Question>{t("faq.qHowBuyAsDistributor")}</Question>
        <Answer>
          {t("faq.aHowBuyAsDistributorBefore")}{" "}
          <Anchor component={Link} to="/tutoriales">
            {t("faq.aHowBuyAsDistributorLink")}
          </Anchor>
        </Answer>

        <Question>{t("faq.qMinimumLicenses")}</Question>
        <Answer>{t("faq.aMinimumLicenses")}</Answer>

        <Question>{t("faq.qHowDeliver")}</Question>
        <Answer>
          {t("faq.aHowDeliverBefore")}{" "}
          <Anchor component={Link} to="/distributorportal">
            {t("faq.aHowDeliverSendLink")}
          </Anchor>
          {t("faq.aHowDeliverMiddle")}{" "}
          <Anchor component={Link} to="/tutoriales">
            {t("faq.aHowDeliverTutorialLink")}
          </Anchor>
        </Answer>

        <Question>{t("faq.qHowLongPurchase")}</Question>
        <Answer>{t("faq.aHowLongPurchase")}</Answer>

        <Question>{t("faq.qHowLongToSell")}</Question>
        <Answer>{t("faq.aHowLongToSell")}</Answer>

        <Question>{t("faq.qHowManyAvailable")}</Question>
        <Answer>
          {t("faq.aHowManyAvailableBefore")}{" "}
          <Anchor component={Link} to="/distributorportal">
            {t("faq.aHowManyAvailableLink")}
          </Anchor>{" "}
          {t("faq.aHowManyAvailableAfter")}
        </Answer>

        <Question>{t("faq.qSoldLicenses")}</Question>
        <Answer>
          {t("faq.aSoldLicensesBefore")}{" "}
          <Anchor component={Link} to="/distributorportal">
            {t("faq.aSoldLicensesLink")}
          </Anchor>
          .
        </Answer>

        <Question>{t("faq.qTryBefore")}</Question>
        <Answer>
          {t("faq.aTryBeforeBefore")}{" "}
          <Anchor href="https://www.dinlabel.com/install">
            https://www.dinlabel.com/install
          </Anchor>{" "}
          {t("faq.aTryBeforeAfter")}
        </Answer>

        <Question>{t("faq.qMainFaq")}</Question>
        <Answer>
          {t("faq.aMainFaqBefore")}{" "}
          <Anchor href="https://www.dinlabel.com/faq">
            https://www.dinlabel.com/faq
          </Anchor>{" "}
          {t("faq.aMainFaqAfter")}
        </Answer>

        <Question>{t("faq.qTutorials")}</Question>
        <Answer>
          {t("faq.aTutorialsBefore")}{" "}
          <Anchor href="https://www.dinlabel.com/tutorials">
            https://www.dinlabel.com/tutorials
          </Anchor>{" "}
          {t("faq.aTutorialsAfter")}
        </Answer>

        <Question>{t("faq.qSupport")}</Question>
        <Answer>{t("faq.aSupport")}</Answer>

        <Question>{t("faq.qOtherQuestion")}</Question>
        <Answer>
          {t("faq.aOtherQuestionBefore")}{" "}
          <Anchor href="mailto:support@dinlabel.com">
            {t("faq.aOtherQuestionLink")}
          </Anchor>
          {t("faq.aOtherQuestionAfter")}
        </Answer>
      </Stack>
    </NavBarContainer>
  );
}
